import $axios from '@/core/api-config'
import { store } from '@/store'

class AttachmentService {
  upload ({ projectId, taskId, data }) {
    const query = projectId ? `projectId=${projectId}` : `taskId=${taskId}`

    const headers = {
      'Content-Type': 'multipart/form-data',
      auth: store.state.auth.token
    }

    return $axios.post(`/api/attachments?${query}`, data, headers)
  }

  uploadShared (projectId, shareId, data) {
    const headers = {
      'Content-Type': 'multipart/form-data'
    }

    return $axios.post(`/api/attachments/share/${projectId}/${shareId}`, data, headers)
  }

  createFile ({ projectId, taskId, mimeType, name, size }) {
    const query = projectId ? `projectId=${projectId}` : `taskId=${taskId}`

    return $axios.post(`/api/attachments/file?${query}`, { mimeType, size, name })
  }

  createFileShared ({ projectId, shareId, name, mimeType, size }) {
    return $axios.post(`/api/attachments/file/share/${projectId}/${shareId}`, { name, mimeType, size })
  }

  updateFile ({ projectId, taskId, url, id }) {
    const query = projectId ? `projectId=${projectId}` : `taskId=${taskId}`

    return $axios.put(`/api/attachments/file/${id}?${query}`, { url })
  }

  updateFileShared ({ projectId, shareId, url, id }) {
    return $axios.put(`/api/attachments/file/share/${id}/${projectId}/${shareId}`, { url })
  }

  clear ({ projectId, taskId, data }) {
    const query = projectId ? `projectId=${projectId}` : `taskId=${taskId}`

    return $axios.post(`/api/attachments/clear?${query}`, data)
  }

  clearShared (projectId, shareId, data) {
    return $axios.post(`/api/attachments/clear/${projectId}/${shareId}`, data)
  }

  delete ({ projectId, taskId, data }) {
    const query = projectId ? `projectId=${projectId}` : `taskId=${taskId}`

    return $axios.post(`/api/attachments/delete?${query}`, data)
  }

  deleteShared (projectId, shareId, id) {
    return $axios.post(`/api/attachments/delete/${projectId}/${shareId}`, id)
  }

  restore ({ projectId, taskId, data }) {
    const query = projectId ? `projectId=${projectId}` : `taskId=${taskId}`

    return $axios.post(`/api/attachments/restore?${query}`, data)
  }

  restoreShared (projectId, shareId, id) {
    return $axios.post(`/api/attachments/restore/${projectId}/${shareId}`, id)
  }

  proxy (url) {
    return $axios.get(`/api/attachments/proxy?url=${url}&responseType=blob`, { responseType: 'blob' })
  }

  getFile ({ id, projectId, taskId }) {
    const query = projectId ? `projectId=${projectId}` : `taskId=${taskId}`

    return $axios.get(`/api/attachments/file/${id}?${query}`)
  }

  getShareFile ({ id, projectId, shareId }) {
    return $axios.get(`/api/attachments/file/${id}/${projectId}/${shareId}`)
  }
}

export const attachmentService = new AttachmentService()
